import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import   { Toaster } from 'react-hot-toast';
import { QueryClient,  QueryClientProvider,  useQuery } from '@tanstack/react-query';
import AuthProvider from './Contexts/AuthProvider';
const queryClient = new QueryClient()
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
   <QueryClientProvider client={queryClient}>
    
      <App />
         <Toaster
  position="top-right"
  reverseOrder={false}
/>
    </QueryClientProvider>
</AuthProvider>

  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
